<template lang='pug'>
//- Follower-Page
div(:class='$style[`cc-follower-board`]')

  div(v-if='isLoading' :class='$style[`cc-loading-data`]')
    IconLoading(:size='28' :color='`#b1b1b1`')

  div(v-else-if='!isLoading && apiDataEmpty' :class='$style[`cc-error`]')
    div(v-show='rwdType === `mobile`' :class='$style[`cc-follower-board-type`]')
      span.font-medium!= '追蹤者'

    figure.graphic.graphic-empty(:class='$style[`cc-error-graphic`]')
    span!= '尚無資料'

  div(v-else-if='!isLoading && !apiDataEmpty' :class='$style[`cc-follower-content`]')
    div(v-show='rwdType === `mobile`' :class='$style[`cc-follower-board-type`]')
      span.font-medium!= '追蹤者'
    ul(:class='$style[`cc-follower-list`]')
      li(v-for='(items, index) in userFollower' :class='$style[`cc-follower-list-user`]')
        //- a(:class='$style[`cc-user-link`]' :href='`/${items.user_type}/${items.id}`' rel='noreferrer')
        router-link(
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-user-link`]'
          :to='{ name: `profile-detail`, params: { type: items.user_type, id: `${items.id}` }}')
          div(v-if='items.user_type === `doctor`')
            figure(v-if='items.thumbSrc === ``' :class='$style[`cc-user-avatar`]')
              div(:class='$style[`cc-user-mask`]')
                span!= '查看'
              //- Doctor-Male-Avatar
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              //- Doctor-Female-Avatar
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            figure(v-else :class='$style[`cc-user-avatar`]')
              div(:class='$style[`cc-user-mask`]')
                span!= '查看'
              img(
                :src='avatarSrcLink(items.thumbSrc)'
                width='100%'
                height='100%')

            div.font-medium(:class='$style[`cc-user-name`]')
              span.font-doctor-theme {{ `${items.firstName}${items.lastName}` }}


          div(v-if='items.user_type === `normal`')
            figure(v-if='items.thumbSrc === `` && !items.public' :class='$style[`cc-user-avatar`]')
              div(:class='$style[`cc-user-mask`]')
                span!= '查看'
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else-if='items.thumbSrc !== `` && !items.public' :class='$style[`cc-user-avatar`]')
              div(:class='$style[`cc-user-mask`]')
                span!= '查看'
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else-if='items.thumbSrc === `` && items.public' :class='$style[`cc-user-avatar`]')
              div(:class='$style[`cc-user-mask`]')
                span!= '查看'
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/normal_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/normal_female.webp`'
                width='100%'
                height='100%')

            figure(v-else-if='items.thumbSrc !== `` && items.public' :class='$style[`cc-user-avatar`]')
              div(:class='$style[`cc-user-mask`]')
                span!= '查看'
              img(
                :src='avatarSrcLink(items.thumbSrc)'
                width='100%'
                height='100%')

            div.font-medium(:class='$style[`cc-user-name`]')
              span.font-normal-theme(
                v-if='items.public ===`yes`'
              ) {{ items.gender === `0` ? `${items.firstName}${items.lastName}` : `${items.firstName}${items.lastName}` }}
              span.font-normal-theme(
                v-else
              ) {{ items.gender === `0` ? `${items.firstName}先生` : `${items.firstName}小姐` }}


    div(v-if='loadedComplete' :class='$style[`cc-follower-result`]')
      infinite-loading(:class='$style[`cc-content-infinite-load`]' :identifier='infiniteId' @infinite='infiniteHandler')
        IconLoading(
          slot='spinner'
          :size='30'
          :color='`#b1b1b1`'
        )
        div.infinite-scroll-slot(slot='no-more')
          span.infinite-scroll-slot-noMore(
          ) 沒有更多資料

        div.infinite-scroll-slot(slot='no-results')
          span.infinite-scroll-slot-noMore(
          ) 沒有更多資料


</template>

<script>
import { mapGetters } from 'vuex';

import {
  getLoadAddFollow,
  // deleteFollow,
} from '../../../js/restapi';

import IconLoading from '../../icon/Loading';

export default {
  metaInfo() {
    return {
      title: `醫護${this.userId}的追蹤者`,
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/${this.userType}/${this.userId}/follower`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/${this.userType}/${this.userId}/follower`,
      }],
    };
  },

  components: {
    IconLoading,
  },

  data() {
    return {
      isLoading: true,
      userType: this.$route.params.type,
      userId: this.$route.params.id,
      // 我的追蹤者列表容器
      // 我的追蹤者列表容器
      loadedActive: false,
      loadedFirstCount: 8,
      loadedCount: 8,
      loadedIndex: 1,
      loadedPreload: false,
      loadedComplete: false,

      apiDataEmpty: false,
      userFollower: [],

      infiniteId: +new Date(),
    };
  },

  created() {
    if (this.$route.params.type === 'normal') {
      this.$router.replace({
        name: 'error404',
      }).catch(() => true);
      return;
    }
    this.handleFirstLoadFromApi(this.$route.params.id, this.loadedIndex);
  },

  methods: {
    infiniteHandler($state) {
      if (this.loadedComplete) {
        this.loadedPreload = true;

        const LOAD_DATA = {
          type: '',
          user_id: '',
          doct_id: `${this.userId}`,
          size: `${this.loadedCount}`,
          page: `${this.loadedIndex}`,
        };

        getLoadAddFollow('', LOAD_DATA, {
          headers: {
            'content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (!response.data.length) {
              // If loaded Complete
              this.loadedPreload = false;
              $state.complete();
              return;
            }
            // Api取得的書籤灌入容器
            const getLoadData = new Promise((resolve) => {
              response.data.forEach((element) => {
                this.userFollower.push(element);
              });
              return resolve(response.data.length);
            });

            getLoadData.then((value) => {
              if (value >= this.loadedCount) {
                this.loadedIndex = this.loadedIndex + 1;
                this.loadedPreload = false;
                $state.loaded();
              } else {
                $state.complete();
              }
            });

            console.log('%c 加入追蹤 Infinite 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;', response.data);
          })
          .catch((error) => {
            console.error('加入追蹤 Infinite 失敗！', error.response);
          });
      } else {
        $state.complete();
      }
    },

    handleFirstLoadFromApi(doctorId, pageIndex) {
      const LOAD_DATA = {
        type: '',
        user_id: '',
        doct_id: `${doctorId}`,
        size: `${this.loadedFirstCount}`,
        page: `${pageIndex}`,
      };

      getLoadAddFollow('', LOAD_DATA, {
        headers: {
          'content-Type': 'application/json',
        },
      })
        .then((response) => {
          // Api取得的書籤灌入容器
          const getLoadData = new Promise((resolve) => {
            response.data.forEach((element) => {
              this.userFollower.push(element);
            });
            return resolve(this.userFollower.length);
          });

          getLoadData.then((value) => {
            this.isLoading = false;
            this.loadedComplete = true;
            this.infiniteId += 1;
            this.loadedIndex = this.loadedIndex + 1;

            if (value === 0) {
              this.apiDataEmpty = true;
            }
          });

          console.log('%c 加入追蹤 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;', response.data);
        })
        .catch((error) => {
          console.error('加入追蹤 失敗！', error.response);
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/member/profileFollower.scss';
</style>
